import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgButtonComponent } from './pg-button.component';
import { PgSpinnerModule } from '../pg-spinner/pg-spinner.module';
import { PgButtonGroupComponent } from './pg-button-group.component';
import { PgButtonFactoryComponent } from './pg-button-factory/pg-button-factory.component';
import { PgIconModule } from '../pg-icon/pg-icon.module';

@NgModule({
  imports: [CommonModule, PgSpinnerModule, PgIconModule],
  declarations: [
    PgButtonComponent,
    PgButtonGroupComponent,
    PgButtonFactoryComponent,
  ],
  exports: [
    PgButtonComponent,
    PgButtonGroupComponent,
    PgButtonFactoryComponent,
  ],
})
export class PgButtonModule {}
